import { NextRouter } from 'next/router';
import { ParsedUrlQueryInput } from 'querystring';

type ReplaceRouteQuery = (
  router: NextRouter,
  query: ParsedUrlQueryInput
) => void;

export const replaceRouteQuery: ReplaceRouteQuery = (router, query) =>
  router.replace(
    {
      query,
    },
    undefined,
    {
      shallow: true,
    }
  );
